import { render, staticRenderFns } from "./IconXmark.vue?vue&type=template&id=4cf98ece&functional=true&"
import script from "./IconXmark.vue?vue&type=script&lang=js&"
export * from "./IconXmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports